<app-message-component
    [title]="title"
    (closeButtonClicked)="closeModal()">
    <div class="submit-issue-content">
        <div class="icon">
            <img src="assets/warning-sign.svg" alt="warning">
        </div>
        <div class="main-message">
            {{message}}
        </div>
        <div class="config-list" *ngIf="existingConfigurations.length > 0">
            <ul class="config-list-ul">
                <li class="config-list-li" *ngFor="let item of existingConfigurations">
                    {{item}}
                </li>
            </ul>
        </div>

        <div class="control-button">
            <button class="btn" (click)="closeModal()">
                {{closeButtonText}}
            </button>
        </div>
    </div>
</app-message-component>
